import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { IMAGES, api } from "@/lib/api";
import { WaitlistForm } from "@/components/WaitlistForm";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    api.get("/waitlist/count").then((r) => setCount(r.data.count)).catch(() => {});
  }, []);

  return (
    <section data-testid="hero-section" className="relative pt-36 md:pt-44 pb-20 md:pb-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 items-center">
        <div>
          <motion.p
            variants={fadeUp} initial="hidden" animate="show" custom={0}
            className="text-xs tracking-[0.25em] uppercase font-bold text-stone-500 mb-6"
            data-testid="hero-eyebrow"
          >
            The iPhone case with a mind of its own
          </motion.p>
          <motion.h1
            variants={fadeUp} initial="hidden" animate="show" custom={1}
            className="font-serif text-6xl md:text-8xl leading-[0.92] tracking-tight text-stone-900"
            data-testid="hero-title"
          >
            Precision<br />
            <span className="italic font-light">Reimagined.</span>
          </motion.h1>
          <motion.p
            variants={fadeUp} initial="hidden" animate="show" custom={2}
            className="mt-8 text-lg md:text-xl leading-relaxed text-stone-600 max-w-md"
            data-testid="hero-subtitle"
          >
            A premium case with an ultra-thin stylus that snaps flush into the frame.
            Zero bulk. Full MagSafe. Always within reach.
          </motion.p>
          <motion.div variants={fadeUp} initial="hidden" animate="show" custom={3} className="mt-10">
            <WaitlistForm plan="Founders Edition" />
            <p className="mt-4 text-sm text-stone-500" data-testid="hero-social-proof">
              {count !== null && count > 0
                ? `Join ${count.toLocaleString()}+ pros reserving the Founders Edition`
                : "Reserve the Founders Edition \u2014 $79, ships Q4 2026"}
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
          className="relative"
          data-testid="hero-image"
        >
          <div className="absolute -inset-6 rounded-[2.5rem] bg-titanium/30 blur-2xl" />
          <img
            src={IMAGES.productAngle}
            alt="Stylo premium iPhone case with integrated stylus"
            className="relative w-full max-w-md mx-auto rounded-3xl object-cover shadow-[0_30px_60px_rgba(0,0,0,0.12)]"
          />
        </motion.div>
      </div>
    </section>
  );
};
